import "core-js/stable";
import "regenerator-runtime/runtime";
import "intersection-observer";
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./registerServiceWorker";
import { FontAwesomeIcon, FontAwesomeLayers } from "@fortawesome/vue-fontawesome";
import BootstrapVue from "bootstrap-vue";
import Vuelidate from "vuelidate";
import VueSweetalert2 from "vue-sweetalert2";
import PageTitle from "./Layout/Components/PageTitle";
import SidebarImage from "./components/SidebarImage";
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import VTooltip from "v-tooltip";
import VueSnackbar from 'vue-snack'
import IdleVue from "idle-vue";

Vue.use(VueSnackbar)
Vue.use(VTooltip);
Vue.use(Vuelidate);
Vue.use(BootstrapVue);
Vue.use(VueSweetalert2);

import MIXINS from "./mixins";
import instance from "./mixins/global_mounted/apiRequest";

Vue.mixin(MIXINS);
Vue.config.productionTip = false;
Vue.prototype.$axios = instance;

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);
Vue.component("PageTitle", PageTitle);
Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.component("font-awesome-layers", FontAwesomeLayers);
Vue.component("sidebar-image", SidebarImage);

Vue.component("page-title", () => import("./Layout/Components/PageTitle.vue"));
Vue.component("page-title-addons", () => import("./Layout/Components/PageTitleAddOns.vue"));
Vue.component("page-title-farmasi", () => import("./Layout/Components/PageTitleDetailFarmasi.vue"));

Vue.component("default-layout", () =>
  import("./Layout/Wrappers/baseLayout.vue")
);
Vue.component("pages-layout", () =>
  import("./Layout/Wrappers/pagesLayout.vue")
);
Vue.component("apps-layout", () => import("./Layout/Wrappers/appLayout.vue"));
Vue.component("examples-layout", () =>
  import("./Layout/Wrappers/layoutsExamples.vue")
);

const eventsHub = new Vue();

var min = 5;

Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  store,
  idleTime: min * 60 * 1000,
  startAtIdle: false
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
